import { Typography } from "@material-ui/core";
import { useEffect, useMemo } from "react";
import {
  DEFAULT_ALLOWED_PAYMENT_METHODS,
  PAYMENT_METHODS,
} from "../../constants/data";
import { LocalizerHelper } from "../../helpers/localizerHelper";
import { useSelector } from "react-redux";
import { RootState } from "../../store";

interface Props {
  setPaymentMethod: (paymentMethod: string) => Promise<void>;
}

export const PaymentMethodButtons = ({setPaymentMethod}: Props) => {
  const session = useSelector((state: RootState) => state.session.session);
  const paymentMethod = useSelector((state: RootState) => state.session.session?.payment_method);

  const allowedMethods = Array.isArray(session?.allowed_payment_methods)
    ? session.allowed_payment_methods
    : DEFAULT_ALLOWED_PAYMENT_METHODS;

  const paymentMethods = useMemo(() => {
    return Object.keys(PAYMENT_METHODS)
      .filter((key) => allowedMethods.includes(key))
      .map((key) => PAYMENT_METHODS[key])
      .sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
  }, [allowedMethods]);

  if (paymentMethods.length <= 1) {
    return null;
  }

  return (
    <div className="container">
      <div style={{ marginBottom: 20 }}>
        <div className="row">
          <div className="col-md-12 text-left">
            <Typography
              variant="h4"
              gutterBottom
              align="left"
              className="recap-header"
            >
              {LocalizerHelper.localized("choose_payment_method")}
            </Typography>
          </div>
        </div>

        <div className="row" style={{ marginTop: 20 }}>
          <div className="col-md-12 text-center">
            <div className="payment_buttons_container">
              {paymentMethods.map((method) => (
                <div
                  key={method.value}
                  className={`payment-method-button ${
                    method.value === paymentMethod ? "selected" : ""
                  }`}
                  onClick={() => setPaymentMethod(method.value)}
                >
                  {LocalizerHelper.localized(method.label)}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
